module.exports = __webpack_public_path__ + "static/media/small_badge.4e7b12c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/small_badge.png
// module id = 201
// module chunks = 0